import { Dialog, DialogTitle, DialogContent, DialogActions, Divider, Box } from "@mui/material";
import { Button } from "@mui/material";
import { useState, useEffect } from "react";
import { DropdownField, LabeledTextField } from "../Codes/PetServiceChargeCodeFormPage";
import apiClient from "../../services/apiClient";

export const PetOrderDialog = ({ open, onClose, order, onSave, type }: any) => {
    const [status, setStatus] = useState<string>("");
    console.log("Order in Dialog:", order);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [serviceProviders, setServiceProviders] = useState<any[]>([]);
    const [selectedProvider, setSelectedProvider] = useState("");
    const [orderDate, setOrderDate] = useState<string>("");
    const [serviceList, setServiceList] = useState<any[]>([]);
    const [selectedService, setSelectedService] = useState("");
    const [chargecodeList, setChargecodeList] = useState<any[]>([]);
    const [selectedChargeCode, setSelectedChargeCode] = useState("");
    const [parentsList, setParentsList] = useState<any[]>([]);
    const [selectedParent, setSelectedParent] = useState("");
    const [selectedParentId, setSelectedParentId] = useState("");
    const [pets, setPets] = useState<any[]>([]);
    const [selectedPet, setSelectedPet] = useState("");
    const [selectedChargeDuration, setSelectedChargeDuration] = useState("");
    const [slots, setSlots] = useState<any[]>([]);
    const [selectedSlot, setSelectedSlot] = useState("");
    const [addOnsList, setAddOnsList] = useState<any[]>([]);
    const [selectedAddOns, setSelectedAddOns] = useState<any[]>([]);
    const [baseAmount, setBaseAmount] = useState<number>(0);
    const [totalAmount, setTotalAmount] = useState<number>(0);
    const [taxRates, setTaxRates] = useState<number[]>([]);

    const resetForm = () => {
        setStatus("");
        setOrderDate("");
        setSelectedProvider("");
        setSelectedService("");
        setSelectedChargeCode("");
        setSelectedParent("");
        setSelectedParentId("");
        setSelectedPet("");
        setSelectedChargeDuration("");
        setSelectedSlot("");
        setSelectedAddOns([]);
        setBaseAmount(0);
        setTotalAmount(0);
        setTaxRates([]);
    };

    const handleCancel = () => {
        resetForm();
        onClose();
    };

    useEffect(() => {
        if (!chargecodeList.length) return;
        const selected = selectedChargeCode
            ? chargecodeList.find(c => c.id.toString() === selectedChargeCode)
            : null;
        const base = selected ? Number(selected.amount ?? 0) : 0;
        const rates = selected?.additional_info?.tax_codes?.map((t: any) =>
            Number(t.rate ?? 0)
        ) ?? [];

        setBaseAmount(base);
        setTaxRates(rates);

        // Calculate add-ons total
        const addOnsTotal = selectedAddOns.reduce(
            (sum, a) => sum + (a.amount ?? a.price ?? 0),
            0
        );
        const taxAmount = rates.reduce(
            (sum: number, rate: number) => sum + (base * rate) / 100,
            0
        );
        const total = base + taxAmount + addOnsTotal;

        setTotalAmount(Number(total.toFixed(2)));
    }, [selectedChargeCode, chargecodeList, selectedAddOns]);

    useEffect(() => {
        if (order?.scheduled_at) {
            const iso = order.scheduled_at.split(".")[0];
            const [datePart] = iso.split("T");
            setOrderDate(datePart);
        } else {
            const today = new Date().toISOString().split("T")[0];
            setOrderDate(today);
        }
    }, [order]);


    useEffect(() => {
        if (!order) return;

        // Order date
        if (order.scheduled_at) {
            const iso = order.scheduled_at.split(".")[0];
            const [datePart] = iso.split("T");
            setOrderDate(datePart);
        }

        // Selected add-ons
        if (order.additional_info?.add_ons?.length) {
            console.log("Setting selected add-ons from order:", order.additional_info.add_ons);
            setSelectedAddOns(order.additional_info.add_ons);
        }

        // Parent / Owner
        if (order.owner?.id) {
            setSelectedParent(order.pet.primary_id.toString());
            setSelectedParentId(order.owner_address?.user_id?.toString() ?? "");
        }

        // Provider
        if (order.service_provider?.id) {
            setSelectedProvider(order.service_provider.id.toString());
        }

        // Service
        if (order.service_charge_code?.service_id) {
            setSelectedService(order.service_charge_code.service_id.toString());
        }

        // Status
        if (order.service_status?.slug) {
            setStatus(order.service_status.slug);
        }
    }, [order]);

    useEffect(() => {
        if (chargecodeList.length > 0) {
            const firstChargeCode = chargecodeList[0].id.toString();
            setSelectedChargeCode(firstChargeCode);
            // set duration
            const minutes = Math.round(parseFloat(chargecodeList[0].duration) * 60);
            setSelectedChargeDuration(`${minutes} minutes`);
        } else {
            setSelectedChargeCode("");
            setSelectedChargeDuration("-");
        }
    }, [chargecodeList]);

    useEffect(() => {
        if (selectedProvider && selectedService && orderDate && selectedChargeCode) {
            fetchSlots(selectedProvider, selectedService, orderDate);
        }
    }, [selectedProvider, selectedService, orderDate, selectedChargeCode]);





    const fetchParents = async () => {
        try {
            setLoading(true);
            const params: any = {
                searchkey: searchQuery || "",
                isActiveUsers: 1,
            };

            const queryString = new URLSearchParams(params).toString();
            const { data } = (await apiClient(
                `v1/resource/patient/all?${queryString}`,
                { method: "GET" }
            )) as any;

            const parentsData = data.patients ?? [];
            setParentsList(parentsData);
        } catch (err: any) {
            setError(err.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };
    const fetchPets = async (parentId: string) => {
        if (!parentId) return; // Don't fetch if parent not selected

        try {
            setLoading(true);

            const params: any = {
                status: "active",
            };

            const queryString = new URLSearchParams(params).toString();
            const { data } = (await apiClient(
                `v1/resource/pets/all?primary_id=${selectedParent}&${queryString}`,
                { method: "GET" }
            )) as any;

            const petsData = data.pets ?? [];
            setPets(petsData);

            // Automatically select the pet from order if exists
            if (order?.pet?.id) {
                const selected = petsData.find((p: any) => p.id === order.pet.id);
                if (selected) setSelectedPet(selected.id.toString());
            }
        } catch (err: any) {
            setError(err.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const fetchServiceProviders = async () => {
        try {
            setLoading(true);

            const params: any = {
                searchkey: searchQuery || "",
                isActiveUsers: 1
            };

            const queryString = new URLSearchParams(params).toString();
            const url = `v1/resource/ServiceProvider/all?${queryString}`;
            console.log("Fetching Service Providers URL:", url); // <-- log URL

            const { data } = (await apiClient(url, { method: "GET" })) as any;

            const providersData = data.service_providers ?? [];
            setServiceProviders(providersData);
        } catch (err: any) {
            setError(err.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const fetchService = async () => {
        try {
            setLoading(true);

            const url = `v1/resource/service/all?service_provider_id=${selectedProvider}`;
            console.log("Fetching Service URL:", url); // <-- log the URL

            const { data } = (await apiClient(url, { method: "GET" })) as any;

            const serviceData = data.services ?? [];
            setServiceList(serviceData);
            const addOnsMap: Record<string, any[]> = {};
            serviceData.forEach((service: any) => {
                if (service.add_ons?.length) {
                    addOnsMap[service.id] = service.add_ons
                        .filter((a: any) => a.is_active)
                        .map((a: any) => ({
                            id: a.name,
                            name: `${a.name} - ${a.price ? `₹${a.price}` : "Free"}`,
                        }));
                } else {
                    addOnsMap[service.id] = [];
                }
            });

            setAddOnsList(addOnsMap[selectedService] ?? []);
        } catch (err: any) {
            setError(err.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };


    const fetchchargecode = async () => {
        if (!selectedProvider || !selectedService) return;

        try {
            setLoading(true);
            const { data } = await apiClient(
                `/v1/resource/ServiceChargeCode?service_provider_id=${selectedProvider}&service_id=${selectedService}`,
                { method: "GET" }
            ) as any;

            const serviceData = data.service_charge_codes ?? [];
            setChargecodeList(serviceData);

            // Auto-select first charge code if available
            if (serviceData.length > 0) {
                const firstId = serviceData[0].id.toString();
                setSelectedChargeCode(firstId);

                // Set duration immediately
                const minutes = Math.round(parseFloat(serviceData[0].duration) * 60);
                setSelectedChargeDuration(`${minutes} minutes`);
            } else {
                setSelectedChargeCode("");
                setSelectedChargeDuration("-");
            }
        } catch (err: any) {
            setError(err.message || "Something went wrong while fetching charge codes");
        } finally {
            setLoading(false);
        }
    };



    const fetchSlots = async (
        service_provider_id: string,
        service_id: string,
        scheduledDate: string
    ) => {
        if (!service_provider_id || !service_id || !scheduledDate) return;

        try {
            setLoading(true);

            const dayName = new Date(scheduledDate)
                .toLocaleDateString('en-US', { weekday: 'long' })
                .replace(/^./, s => s.toUpperCase());

            const queryString = new URLSearchParams({
                service_provider_id,
                service_id,
                day: dayName,
                date: scheduledDate,
            }).toString();

            const { data } = (await apiClient(
                `v1/resource/ServiceAvailability/slots?${queryString}`,
                { method: "GET" }
            )) as any;

            const selectedCharge = chargecodeList.find(c => c.id.toString() === selectedChargeCode);
            const durationMinutes = selectedCharge ? Math.round(parseFloat(selectedCharge.duration) * 60) : 30;

            let splittedSlots = splitSlotsByDuration(data.slots?.time_ranges ?? [], durationMinutes);

            // Filter out past time slots if selected date is today
            const today = new Date();
            if (scheduledDate === today.toISOString().split('T')[0]) {
                splittedSlots = splittedSlots.filter(slot => {
                    const [hourMin, period] = slot.start_time.split(' ');
                    const [hour, min] = hourMin.split(':').map(Number);
                    let slotHour = hour % 12;
                    if (period === "PM") slotHour += 12;

                    return slotHour > today.getHours() || (slotHour === today.getHours() && min > today.getMinutes());
                });
            }

            setSlots(splittedSlots);

            // Preselect slot
            if (order?.scheduled_at) {
                const scheduledTime = new Date(order.scheduled_at);
                const matchedSlot = splittedSlots.find(slot => {
                    const [hourMin, period] = slot.start_time.split(' ');
                    const [hour, min] = hourMin.split(':').map(Number);
                    let slotHour = hour % 12;
                    if (period === "PM") slotHour += 12;
                    return slotHour === scheduledTime.getHours() && min === scheduledTime.getMinutes();
                });
                if (matchedSlot) setSelectedSlot(matchedSlot.id.toString());
                else if (splittedSlots.length) setSelectedSlot(splittedSlots[0].id.toString());
            } else if (splittedSlots.length) {
                setSelectedSlot(splittedSlots[0].id.toString());
            }

        } catch (err: any) {
            setError(err.message || "Something went wrong while fetching slots");
        } finally {
            setLoading(false);
        }
    };


    const splitSlotsByDuration = (slots: any[], durationMinutes: number) => {
        const result: any[] = [];

        slots.forEach((slot: any) => {
            const [startHour, startMin, startPeriod] = slot.start.split(/:| /);
            const [endHour, endMin, endPeriod] = slot.end.split(/:| /);

            // Convert to 24h minutes
            let start = parseInt(startHour) % 12 * 60 + parseInt(startMin);
            if (startPeriod === "PM") start += 12 * 60;

            let end = parseInt(endHour) % 12 * 60 + parseInt(endMin);
            if (endPeriod === "PM") end += 12 * 60;

            // Split
            while (start + durationMinutes <= end) {
                const startH = Math.floor(start / 60);
                const startM = start % 60;
                const endH = Math.floor((start + durationMinutes) / 60);
                const endM = (start + durationMinutes) % 60;

                const formatTime = (h: number, m: number) => {
                    const period = h >= 12 ? "PM" : "AM";
                    const hour12 = h % 12 === 0 ? 12 : h % 12;
                    return `${hour12}:${m.toString().padStart(2, "0")} ${period}`;
                };

                result.push({
                    id: `${slot.start}-${slot.end}-${start}`, // unique id
                    start_time: formatTime(startH, startM),
                    end_time: formatTime(endH, endM),
                });

                start += durationMinutes;
            }
        });

        return result;
    };

    useEffect(() => {
        if (selectedParent) {
            fetchPets(selectedParent);
        }
    }, [selectedParent]);

    useEffect(() => {
        if (order?.pet?.id && pets.length > 0) {
            const pet = pets.find(p => p.id === order.pet.id);
            if (pet) {
                setSelectedPet(pet.id.toString());
            }
        }
    }, [pets, order]);
    useEffect(() => {
        fetchService();
        fetchParents();
    }, []);

    useEffect(() => {
        if (selectedProvider) {
            fetchService();
            setSelectedService("");
            setChargecodeList([]);
            setSelectedChargeCode("");
            setAddOnsList([]);
            setSelectedAddOns([]);
        } else {
            setServiceList([]);
        }
    }, [selectedProvider]);
    // After fetching service list
    useEffect(() => {
        if (order && serviceList.length) {
            const serviceId = order.service_charge_code?.service_id?.toString();
            if (serviceId) {
                setSelectedService(serviceId);
            }
        }
    }, [serviceList, order]);

    // After fetching charge codes
    useEffect(() => {
        if (order && chargecodeList.length) {
            const chargeCodeId = order.service_charge_code?.id?.toString();
            if (chargeCodeId) {
                setSelectedChargeCode(chargeCodeId);
            }
        }
    }, [chargecodeList, order]);
    useEffect(() => {
        if (selectedService && serviceList.length) {
            const service = serviceList.find(s => s.id.toString() === selectedService);
            const addOns = service?.add_ons?.filter((a: { is_active: any; }) => a.is_active) || [];
            setAddOnsList(addOns);

            if (order?.additional_info?.add_ons?.length) {
                const selected = addOns.filter((a: { name: any; }) =>
                    order.additional_info.add_ons.some((o: { name: any; }) => o.name === a.name)
                );
                setSelectedAddOns(selected);
            }
        } else {
            setAddOnsList([]);
            setSelectedAddOns([]);
        }
    }, [selectedService, serviceList, order]);

    useEffect(() => {
        if (selectedProvider && selectedService) {
            fetchchargecode();
        } else {
            setChargecodeList([]);
            setSelectedChargeCode("");
        }
    }, [selectedProvider, selectedService]);


    useEffect(() => {
        if (selectedChargeCode && chargecodeList.length) {
            const selected = chargecodeList.find(c => c.id.toString() === selectedChargeCode);
            if (selected) {
                setBaseAmount(selected.amount ?? 0);
            } else {
                setBaseAmount(0);
            }
        }
    }, [selectedChargeCode, chargecodeList]);
    useEffect(() => {
        const selected = chargecodeList.find(c => c.id.toString() === selectedChargeCode);
        if (selected?.duration) {
            const minutes = Math.round(parseFloat(selected.duration) * 60);
            setSelectedChargeDuration(`${minutes} minutes`);
        } else {
            setSelectedChargeDuration("-");
        }
    }, [selectedChargeCode]);


    useEffect(() => {
        if (selectedService) {
            const service = serviceList.find(s => s.id.toString() === selectedService);
            if (service) {
                const addOns = service.add_ons?.filter((a: { is_active: boolean }) => a.is_active) || [];
                setAddOnsList(addOns);
                if (order?.additional_info?.add_ons?.length) {
                    const selected = addOns.filter((a: { name: string }) =>
                        order.additional_info.add_ons.some((o: { name: string }) => o.name === a.name)
                    );
                    setSelectedAddOns(selected);
                }
            } else {
                setAddOnsList([]);
                setSelectedAddOns([]);
            }
        }
    }, [selectedService, serviceList, order]);


    useEffect(() => {
        fetchServiceProviders();
    }, [searchQuery]);


    const handleSave = () => {
        const slotObj = slots.find(s => s.id.toString() === selectedSlot);
        let scheduledAt = null;
        if (orderDate && slotObj?.start_time) {
            scheduledAt = `${orderDate} ${slotObj.start_time}`;
        }
        const payload = {
            id: order?.id,
            users_id: order?.owner_address?.user_id || selectedParentId,
            pet_id: selectedPet,
            service_provider_id: selectedProvider,
            service_charge_code_id: selectedChargeCode,
            hours: selectedChargeDuration ? parseFloat(selectedChargeDuration) / 60 : 0, // convert minutes to hours
            status: status || order?.service_status?.slug,
            total_amount: totalAmount,
            scheduled_at: scheduledAt || order?.scheduled_at,
            additional_info: {
                ...order?.additional_info, // include order_id, payment_id, payment_retries, etc.
                note: order?.additional_info?.note?.trim() ?? "",
                add_ons: selectedAddOns.map((addon) => ({
                    name: addon.name,
                    amount: addon.price ?? 0,
                })),
            },
        };

        console.log("Payload to save:", payload);
        onSave(payload);
        onClose();
    };



    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    padding: 2,
                    background: "#f9fafb",
                    position: "relative",
                },
            }}
        >
            <DialogTitle sx={{ fontWeight: 600, color: "#333" }}>
                {type === "edit" ? "Edit Service Order" : "Add Service Order"}
            </DialogTitle>

            <Divider />
            <DialogContent
                sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}
            >
                <Box sx={{ display: "flex", gap: 2 }}>
                    <LabeledTextField
                        label="Order Date"
                        type="date"
                        value={orderDate}
                        onChange={(val) => setOrderDate(val)}
                        helperText="Select or edit the order date"
                    />
                    <DropdownField
                        label="Service Provider"
                        value={selectedProvider}
                        onChange={(val) => setSelectedProvider(val)}
                        helperText="Select a service provider"
                        options={serviceProviders.map((sp: any) => ({
                            id: sp.id.toString(),
                            name: `${sp.user?.first_name ?? ""} ${sp.user?.last_name ?? ""}`.trim(),
                        }))}
                    />
                    <DropdownField
                        label="Service Type"
                        value={selectedService}
                        onChange={(val) => setSelectedService(val)}
                        helperText="Select a service"
                        options={serviceList.map((s: any) => ({
                            id: s.id.toString(),
                            name: s.services_name,
                        }))}
                    />
                </Box>
                <Box sx={{ display: "flex", gap: 2 }}>


                    <DropdownField
                        label="Parent Name"
                        value={selectedParent}
                        onChange={(val) => {
                            setSelectedParent(val); // val is parent.id as string
                            // Find the parent object by id
                            const parentObj = parentsList.find(p => p.id.toString() === val);
                            const userId = parentObj?.user_id?.toString() ?? "";
                            setSelectedParentId(userId); // store the actual user_id
                        }}
                        helperText="Select a parent"
                        options={parentsList.map((p: any) => ({
                            id: p.id.toString(), // this is the value returned by onChange
                            name: `${p?.user?.first_name ?? "-"} ${p.user?.last_name ?? "-"}`,
                        }))}
                    />

                    <DropdownField
                        label="Pet Name"
                        value={selectedPet}
                        onChange={(val) => setSelectedPet(val)}
                        helperText="Select a pet"
                        options={pets.map((p: any) => ({
                            id: p.id.toString(),
                            name: p?.additional_info?.name ?? "-",
                        }))}
                    />
                    <DropdownField
                        label="Charge Codes"
                        value={selectedChargeCode}
                        onChange={(val) => setSelectedChargeCode(val)}
                        helperText="Select a charge code"
                        options={chargecodeList.map((c: any) => ({
                            id: c.id.toString(),
                            name: `${c.charge_code}-${c.service_name}`,
                        }))}
                    />
                </Box>

                <Box sx={{ display: "flex", gap: 2 }}>
                    <LabeledTextField
                        label="Duration (in minutes)"
                        value={selectedChargeDuration}
                        onChange={() => { }}
                        disabled
                    />
                    {(!order || status === "reschedule_requested") ? (
                        <DropdownField
                            label="Available Slots"
                            value={selectedSlot}
                            onChange={(val) => setSelectedSlot(val)}
                            helperText="Select a slot"
                            options={slots.map((slot: any) => ({
                                id: slot.id.toString(),
                                name: `${slot.start_time} - ${slot.end_time}`,
                            }))}
                        />
                    ) : (
                        <LabeledTextField
                            label="Scheduled Slot"
                            value={
                                slots.find(s => s.id.toString() === selectedSlot)?.start_time || ""
                            }
                            onChange={() => { }}
                            disabled
                            helperText="Current scheduled slot"
                        />
                    )}
                    <DropdownField
                        label="Optional Add-Ons"
                        value={selectedAddOns.map(a => a.name)}
                        onChange={(val: string[]) => {
                            const selected = addOnsList.filter(a => val.includes(a.name));
                            setSelectedAddOns(selected);
                        }}
                        helperText="Select optional add-ons for the service"
                        options={addOnsList.map(a => ({
                            id: a.name,
                            name: `${a.name} - ${a.price ? `₹${a.price}` : "Free"}`,
                        }))}
                        multiple
                    />

                </Box>

                <Box sx={{ display: "flex", gap: 2 }}>
                    <LabeledTextField
                        label="Base Amount"
                        type="number"
                        value={baseAmount}
                        onChange={() => { }}
                        helperText="Amount in ₹"
                        disabled
                    />
                    <LabeledTextField
                        label="Total Amount"
                        type="number"
                        value={totalAmount}
                        onChange={() => { }}
                        disabled
                        helperText={`Including taxes (${taxRates.join("% + ")}%)`}
                    />
                    <DropdownField
                        label="Status"
                        value={status}
                        onChange={(val) => setStatus(val)}
                        helperText="Select order status"
                        options={[
                            { id: "created", name: "Created" },
                            { id: "awaiting_serviceprovider_confirmation", name: "Awaiting Service Provider Confirmation" },
                            { id: "booking_confirmed", name: "Booking Confirmed" },
                            { id: "service_accepted_unpaid", name: "Service Accepted Unpaid" },
                            { id: "paid_confirmed", name: "Paid Confirmed" },
                            { id: "reschedule_requested", name: "Reschedule Requested" },
                            { id: "reschedule_declined", name: "Reschedule Declined" },
                            { id: "inprogress", name: "Service Inprogress" },
                            { id: "completed", name: "Completed" },
                            { id: "no_show_petowner", name: "No Show Petowner" },
                            { id: "no_show_serviceprovider", name: "No Show Serviceprovider" },
                            { id: "cancelled_petowner", name: "Cancelled PetOwner" },
                            { id: "cancelled_serviceprovider", name: "Cancelled Serviceprovider" },
                            { id: "expired", name: "Expired" },
                            { id: "refund_initiated", name: "Refund Initiated" },
                            { id: "refund_completed", name: "Refund Completed" },
                            { id: "settlement_pending", name: "Settlement Pending" },
                            { id: "settlement_inprogress", name: "Settlement Inprogress" },
                            { id: "settled", name: "Settled" },
                        ]}
                    />

                </Box>
                {order && (
                    <Box sx={{ display: "flex", gap: 2 }}>
                        <LabeledTextField
                            label="Mobile Number"
                            value={order.owner?.mobile ?? ""}
                            disabled
                            onChange={() => { }}
                            helperText="Parent's registered mobile number"
                        />
                        <LabeledTextField
                            label="Order ID"
                            value={order.additional_info?.order_id ?? ""}
                            onChange={() => { }}
                            helperText="Unique code for the order"
                            disabled
                        />
                    </Box>
                )}

            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="inherit">Cancel</Button>
                <Button onClick={handleSave} variant="contained" color="primary">
                    {type === "edit" ? "Update" : "Save"}
                </Button>

            </DialogActions>
        </Dialog>
    );
};
